<template>
  <div class="page-container">
    <el-form :model="mediaModel" label-width="110px" label-position="left">
      <div class="media-row">
        <el-form-item label="素材">
          <div v-if="mediaModel.mediaId" class="img-container">
            <el-image fit="contain" :src="mediaModel.mediaIcon" style="display:block" />
            <div class="img-mask">
              <el-button type="primary" plain @click="showCreativeCentre = true">从素材库选择</el-button>
            </div>
          </div>
          <div v-else class="media-container" @click="showCreativeCentre = true">
            <i class="el-icon el-icon-picture-outline"> 从素材库选择</i>
          </div>
        </el-form-item>
        <div v-if="mediaModel.mediaId" :span="12" class="media-right-item">
          <el-form-item label="素材ID">{{ mediaModel.mediaId }}</el-form-item>
          <el-form-item label="素材名称">{{ mediaModel.mediaName }}</el-form-item>
          <el-form-item label="素材类型">{{ mediaModel.adMediaClass.mediaClassName }}</el-form-item>
          <el-form-item label="素材状态">
            <i class="dot" :style="{ backgroundColor: statusColors[mediaModel.checkStatus] }"></i>
            <span>{{ $consts.materialStatisText[mediaModel.checkStatus] }}</span>
            <span v-if="mediaModel.checkStatus !== 4" style="padding-left:10px;color:#999">(审核且测试通过后，计划单才可生效)</span>
          </el-form-item>
          <el-form-item label="广告主">{{ mediaModel.partnerName }}</el-form-item>
          <el-form-item label="广告位">{{ mediaModel.adSpaceName }}</el-form-item>
        </div>
      </div>
      <el-row>
        <el-col :span="22" style="display:flex;gap:40px">
          <el-form-item v-if="mediaModel.minIcon" label="封面图">
            <el-image
              cover
              style="width: 300px;background-color:#3e649a;"
              :src="mediaModel.minIcon"
              :preview-src-list="[mediaModel.minIcon]"
            ></el-image>
          </el-form-item>
          <el-form-item v-if="mediaModel.bgIcon" label="背景图" label-width="70px">
            <el-image
              cover
              style="width: 300px;background-color:#3e649a;"
              :src="mediaModel.bgIcon"
              :preview-src-list="[mediaModel.bgIcon]"
            ></el-image>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="adSpaceModel.supportAdditionalMedia === 1">
        <el-col :span="22">
          <el-form-item label="附加素材配置">
            <div class="flex-form-item">
              <AdditionalMediaConfig
                :adSpaceModel="adSpaceModel"
                :additionalMediaList="mediaModel.additionalMediaList"
                @change="setAdditionalMedia"
              />
              <el-tooltip class="item" effect="light" placement="top-start">
                <i class="el-icon-cc-question-circle" style="font-size: 16px;line-height: 36px;"></i>
                <div slot="content">
                  <template v-if="adSpaceModel.spaceNo === 'CCADTV10016'">
                    非必填，如配置附加素材，落焦时，素材将自动播放、预览附加素材。仅限视频
                  </template>
                  <template v-else>
                    非必填<br />
                    - 如配置附加素材，则展示半屏的inline形式：<br />
                    上面的素材则作为主图展示(第一个焦点图)<br />
                    - 如不配置附加素材，则为全屏的inline形式
                  </template>
                </div>
              </el-tooltip>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="mediaModel.guideIcon">
        <el-col :span="22">
          <el-form-item label="弹窗引导图">
            <el-image
              cover
              style="width: 300px;"
              :src="mediaModel.guideIcon"
              :preview-src-list="[mediaModel.guideIcon]"
            ></el-image>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="22">
          <el-form-item label="显示时长">
            <template v-if="mediaModel.mediaClassId === 1 && !durationDisabled">
              <el-input-number
                v-model="mediaModel.duration"
                controls-position="right"
                :disabled="durationDisabled || true"
                :min="adSpaceModel.duratMinint"
                :max="adSpaceModel.duratMaxint"
              ></el-input-number>&nbsp; 秒
              <div class="remark-tip">请输入{{ adSpaceModel.duratMinint }}到{{ adSpaceModel.duratMaxint }}的数</div>
            </template>
            <span v-else>{{ mediaModel.duration || '-' }} 秒</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="showCoordinate">
        <el-col :span="22">
          <el-form-item label="显示位置">
            <el-radio-group v-model="mediaModel.locationType" :disabled="true">
              <el-radio-button v-for="(item, index) in locationTypeOptions" :key="index" :label="item.label">{{ item.value }}</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <template v-if="mediaModel.locationType === 10">
            <el-form-item label="X轴">
              <el-input-number v-model.trim="mediaModel.coordinateX" controls-position="right" :disabled="true"></el-input-number>&nbsp;px
            </el-form-item>
            <el-form-item label="Y轴">
              <el-input-number v-model.trim="mediaModel.coordinateY" controls-position="right" :disabled="true"></el-input-number>&nbsp;px
            </el-form-item>
          </template>
        </el-col>
      </el-row>
      <el-row v-if="showEffect">
        <el-col :span="22">
          <el-form-item label="动画效果">
            <el-radio-group v-model="mediaModel.effect" :disabled="true">
              <el-radio-button v-for="(item, index) in effectOptions" :label="item.label" :key="index">{{ item.value }}</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="showLandPage">
        <el-col :span="22">
          <el-form-item class="land-page-item" label="跳转地址">
            <el-radio-group v-model="mediaModel.landPage" :disabled="true">
              <el-radio-button :label="0">无</el-radio-button>
              <el-radio-button :label="1">自定义</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="mediaModel.landPage === 1" class="land-page-item" label-width="20px">
            <el-input
              v-model="mediaModel.landingPage"
              v-noEmoji
              class="land-page-input"
              maxlength="100"
              placeholder="请输入跳转地址"
              :disabled="true"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="showTargetEvent">
        <el-col :span="22">
          <el-form-item label="交互事件">
            <el-radio-group v-model="mediaModel.shipType" @change="handleShipTypeChange">
              <el-radio-button label="NONE">无</el-radio-button>
              <el-radio-button v-for="event in eventOptions" :key="event.shipType" :label="event.shipType">{{ event.name }}</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="mediaModel.shipType !== 'NONE'">
            <div class="event-wrapper">
              <TargetEventItem
                :partnerId="scheduleForm.partnerId"
                :ship-type="mediaModel.shipType"
                :model="mediaModel.targetEvent"
                :eventTempList="eventTempList"
                @temp-change="handleTargetEventChange"
              />
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="22">
          <el-form-item label="提示语">
            <AdTipsEditorNew
              ref="tipsEditor"
              :tipsTempId="mediaModel.tipsTempId"
              :tipsDetail="mediaModel.tipsDetail"
              :spaceId="scheduleForm.spaceId"
              :targetEventType="mediaModel.targetEventType"
              @change-tips="saveTips"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="adSpaceModel.supportFeedContent === 1">
        <el-col :span="16">
          <el-form-item label="创意标题">
            <el-input
              v-model="mediaModel.creativeTitle"
              clearable
              show-word-limit
              placeholder="请输入创意标题"
              :maxlength="30"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="showButtonText">
        <el-col :span="8">
          <el-form-item label="点击按钮文案">
            <el-input
              v-model="mediaModel.clickButtonContent"
              clearable
              show-word-limit
              style="width:300px"
              placeholder="请输入点击按钮文案，例如：查看详情、立即购买"
              :maxlength="6"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="22">
          <el-form-item label="监测代码">
            <el-radio-group v-model="mediaModel.codeType" :disabled="mediaModel.codeTypeDisabled" @change="handleChangeCodeType">
              <el-radio-button v-for="(item, index) in codeTypeOptions" :label="item.label" :key="index">{{ item.value }}</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="mediaModel.codeType !== 0">
            <el-tabs v-model="mediaModel.tabTrackType" type="border-card" style="padding: 0">
              <el-tab-pane
                v-for="item in showingTrackOptions"
                :key="item.queue"
                :label="`${item.name}(${mediaModel.codeType === 1 ? shareTrackModel[item.key].length : mediaModel[item.key].length})`"
                :name="item.key"
              >
                <!-- 素材通用 -->
                <MediaTrack
                  v-if="mediaModel.codeType === 1"
                  :trackKey="item.type"
                  :trackTypeList="trackTypeList"
                  :providerList="providerList"
                  :sdkProviderList="sdkProviderList"
                  :trackList="shareTrackModel[item.key]"
                  :supportPointTrack="supportPointTrack"
                  :pointList="pointList"
                ></MediaTrack>
                <!-- 区分素材 -->
                <MediaTrack
                  v-if="mediaModel.codeType === 2"
                  :trackKey="item.type"
                  :trackTypeList="trackTypeList"
                  :providerList="providerList"
                  :sdkProviderList="sdkProviderList"
                  :trackList="mediaModel[item.key]"
                  :supportPointTrack="supportPointTrack"
                  :pointList="pointList"
                ></MediaTrack>
              </el-tab-pane>
            </el-tabs>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="showMobileTrack">
        <el-col :span="22">
          <el-form-item label="移动端监测">
            <el-radio-group v-model="mediaModel.useMobileTrack" @change="handleUseMobileTrackChange">
              <el-radio-button :label="0">不使用</el-radio-button>
              <el-radio-button :label="1">使用</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="mediaModel.useMobileTrack === 1" label="">
            <div v-for="(mTrack, mIdx) in mediaModel.mobileTrackList" :key="mIdx" class="flex-form-item">
              <el-select :value="mTrack.trackTypeModel" disabled>
                <el-option :value="1" label="API类型"></el-option>
              </el-select>
              <el-select v-model="mTrack.serviceProvider" placeholder="监测商">
                <el-option v-for="(opt,idx) in providerList" :key="idx" :value="opt.providerNo" :label="opt.providerName"></el-option>
              </el-select>
              <el-input v-model="mTrack.code" placeholder="请输入监测代码" clearable></el-input>
              <el-button @click="handleMobileTrackDel(mIdx)">删除</el-button>
            </div>
            <el-button type="primary" @click="handleMobileTrackAdd">增加代码</el-button>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="existTargetEvent">
        <el-col :span="22">
          <el-form-item label="落地页监测">
            <el-radio-group v-model="mediaModel.codeTypeLanding" @change="handleCodeTypeLandingChange">
              <el-radio-button :label="0">不使用</el-radio-button>
              <el-radio-button :label="1">使用</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="mediaModel.codeTypeLanding === 1" label="">
            <el-tabs v-model="mediaModel.tabTrackTypeLanding" type="border-card" style="padding: 0">
              <el-tab-pane
                v-for="item in landingTrackOptions"
                :key="item.queue"
                :label="`${item.name}(${mediaModel[item.key + 'Landing'].length})`"
                :name="item.key"
              >
                <MediaTrack
                  :providerList="providerList"
                  :sdkProviderList="sdkProviderList"
                  :trackList="mediaModel[item.key + 'Landing']"
                ></MediaTrack>
              </el-tab-pane>
            </el-tabs>
          </el-form-item>
          <el-form-item label="落地页提示">
            <LandingPageTips :init-tips-detail="mediaModel.landingTipsDetail[0]" @tips-change="setLandingPageTips" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <CommonUploadTable
      v-model="showCreativeCentre"
      :mediaQuery="{
        checkStatusArray: [1, 2, 4],
        width: recStreamInfo ? recStreamInfo.mediaWidth : undefined,
        height: recStreamInfo ? recStreamInfo.mediaHeight : undefined,
        mediaClassId: isHomeRecommendationSpace ? 1 : undefined
      }"
      :mediaList="mediaModelList"
      :orderScheduleForm="scheduleForm"
      @selected-media="handleSelectedMedia"
    />
  </div>
</template>

<script>
import CommonUploadTable from '@/components/CommonUploadTable.vue'
import AdTipsEditorNew from '@/components/media/AdTipsEditorNew.vue'
import TargetEventItem from '@/components/targetEvent/TargetEventItem.vue'
import MediaTrack from '@/components/MediaTrack.vue'
import LandingPageTips from '../creative/components/LandingPageTips.vue'
import AdditionalMediaConfig from './AdditionalMediaConfig.vue'
import { locationTypeOptions, effectOptions, codeTypeOptions, trackOptions, eventOptions, genTargetEvent } from './MaterialCreative'
import { shareTrackCode } from './creativeUtil'

export default {
  components: {
    CommonUploadTable,
    AdTipsEditorNew,
    TargetEventItem,
    MediaTrack,
    LandingPageTips,
    AdditionalMediaConfig,
  },
  props: {
    adSpaceModel: {
      type: Object,
      default: () => ({})
    },
    scheduleForm: {
      type: Object,
      default: () => ({})
    },
    mediaModel: {
      type: Object,
      default: () => ({})
    },
    mediaModelList: {
      type: Array,
      default: () => []
    },
    shareTrackModel: {
      type: Object
    },
    providerList: {
      type: Array,
      default: () => []
    },
    mediaIndex: {
      type: Number,
      default: 0
    },
    recStreamInfo: {
      type: Object,
      default: null
    },
    sdkProviderList: {
      type: Array,
      default: () => []
    },
    pointList: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      showCreativeCentre: false,
      locationTypeOptions,
      effectOptions,
      codeTypeOptions,
      trackOptions,
      eventOptions,
      statusColors: ['', '', '', '', '', '', '']
    }
  },
  computed: {
    durationDisabled() {
      return this.adSpaceModel.durationint === 0 || this.mediaModel.mediaClassId !== 1
    },
    showCoordinate() {
      return this.adSpaceModel.coordinate === 1
    },
    showEffect() {
      return this.adSpaceModel.spaceNo === 'CCADTV10004'
    },
    showMobileTrack() {
      return this.adSpaceModel.spaceNo === 'CCADTV10040'
    },
    isHomeRecommendationSpace() {
      return this.adSpaceModel.spaceNo === 'CCADTV10016'
    },
    showLandPage() {
      return this.adSpaceModel.needLandingPage === 13
    },
    showTargetEvent() {
      return this.adSpaceModel.targetEvent === 1
    },
    trackTypeList() {
      return this.adSpaceModel.trackTypeList ? JSON.parse(this.adSpaceModel.trackTypeList) : []
    },
    existTargetEvent() {
      return this.mediaModel.shipType !== 'NONE' && this.mediaModel.targetEvent.targetTempId !== -1
    },
    existTrackCode() {
      return trackOptions.some(tab => {
        let trackList = this.mediaModel.codeType === 1 ? this.shareTrackModel[tab.key] : this.mediaModel[tab.key]
        if (trackList.length) {
          return trackList.some(track => track.code !== '')
        }
        return false
      })
    },
    showButtonText() {
      return this.adSpaceModel.supportFeedContent === 1 && this.mediaModel.shipType === 'KEY' && this.mediaModel.targetEvent.targetTempId > -1
    },
    supportPointTrack() {
      return this.adSpaceModel.pointTrack === 1
    },
    landingTrackOptions() {
      return trackOptions.filter(opt => opt.key !== 'pointTrackList')
    },
    showingTrackOptions() {
      if (this.supportPointTrack) {
        return trackOptions
      }
      return trackOptions.filter(opt => opt.key !== 'pointTrackList')
    },
  },
  inject: ['eventTempList'],
  created() {
    this.statusColors = this.$consts.materialStatusOptions.map(item => item.color)
  },
  methods: {
    // 从素材库选择
    handleSelectedMedia(rowData) {
      if (!rowData.mediaDetailList || rowData.mediaDetailList.length === 0) {
        return this.$message.error('选择的素材异常')
      }
      if (this.adSpaceModel.brandIcon === 1 && rowData.mediaClassId === 2 && !rowData.minIcon) {
        return this.$message.error('所选广告位素材必须添加封面图才可以投放，建议您前往【素材库】编辑素材添加该内容')
      }
      const row = rowData.mediaDetailList[0]
      let media = this.mediaModel
      media.mediaName = rowData.mediaName
      media.spaceId = rowData.spaceId
      media.partnerName = rowData.adDspPartner.partnerName
      media.adSpaceName = rowData.adSpace.spaceName
      media.adMediaClass.mediaClassName = rowData.adMediaClass.mediaClassName
      media.mediaId = rowData.mediaId
      media.mediaClassId = rowData.mediaClassId
      media.md5 = rowData.md5
      media.checkStatus = rowData.checkStatus
      media.materialId = 0
      media.materialName = rowData.mediaName
      media.minIcon = rowData.minIcon
      media.bgIcon = rowData.bgIcon
      media.guideIcon = rowData.guideIcon
      if (row.duration) {
        media.duration = row.duration
      }
      if (row.landingPage) {
        media.landPage = 1
        media.landingPage = row.landingPage
      } else {
        media.landPage = 0
        media.landingPage = ''
      }
      if (row.locationType !== undefined) {
        media.locationType = row.locationType
      }
      if (row.coordinateX !== undefined) {
        media.coordinateX = row.coordinateX
      }
      if (row.coordinateY !== undefined) {
        media.coordinateY = row.coordinateY
      }
      if (row.effect) {
        media.effect = row.effect
      }
      media.mediaIcon = rowData.mediaIcon
      this.showCreativeCentre = false
    },
    setAdditionalMedia(mediaList) {
      this.mediaModel.additionalMediaList = mediaList
    },
    handleShipTypeChange(val) {
      if (val === 'NONE') {
        this.mediaModel.targetEvent = genTargetEvent()
        this.handleTargetEventChange(4)
      }
      this.mediaModel.clickButtonContent = ''
    },
    // 切换交互事件模板
    handleTargetEventChange(targetEventType) {
      this.mediaModel.targetEventType = targetEventType
      if (this.mediaModel.tipsTempId === undefined && this.mediaModel.tipsDetail) {
        this.$alert('由于交互事件类型变更，提示语将清空，请重新设置', '提示', {
          confirmButtonText: '确定',
          callback: action => {
            this.mediaModel.tipsTempId = undefined
            this.mediaModel.tipsDetail = ''
          }
        })
      }
    },
    saveTips(data) {
      this.mediaModel.tipsTempId = data.tipsTempId
      this.mediaModel.tipsDetail = data.tipsDetail
    },
    // 切换监测代码类型
    handleChangeCodeType(val) {
      if (val === 0 && this.existTrackCode) {
        this.$confirm('切换监测代码使用方式将删除已填写的监测代码，是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          center: true,
          showClose: false
        })
          .then(() => {
            // 从通用改为无，其他素材分配通用code
            if (this.mediaModel.oringinalCodeType === 1 && this.mediaModelList.length > 1) {
              this.distributeShareCode()
            }
            this.clearTrackCode()
            this.mediaModel.oringinalCodeType = val
          })
          .catch(() => {
            this.mediaModel.codeType = this.mediaModel.oringinalCodeType
          })
      } else if (val === 1 && this.mediaModelList.length > 1 && this.mediaModel.oringinalCodeType !== 1) {
        // 切换为素材通用， 监测代码应用于所有素材
        this.$confirm('确定将当前监测代码应用于所有素材？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          center: true,
          showClose: false
        })
          .then(() => {
            // 所有素材切换为通用
            this.mediaModelList.forEach(media => {
              media.codeType = val
            })
            shareTrackCode(this.shareTrackModel, this.mediaModel)
            this.mediaModel.oringinalCodeType = val
          })
          .catch(() => {
            this.mediaModel.codeType = this.mediaModel.oringinalCodeType
          })
      } else {
        // 从通用改为区分，所有素材分配通用code
        if (this.mediaModel.oringinalCodeType === 1 && this.mediaModelList.length > 1) {
          this.distributeShareCode()
        }
        shareTrackCode(this.mediaModel, this.shareTrackModel)
        this.mediaModel.oringinalCodeType = val
      }
    },
    clearTrackCode() {
      this.mediaModel.trackList = []
      this.mediaModel.clickTrackList = []
      this.mediaModel.startTrackList = []
      this.mediaModel.middleTrackList = []
      this.mediaModel.endTrackList = []
      this.mediaModel.pointTrackList = []
    },
    distributeShareCode() {
      this.mediaModelList.forEach((media, index) => {
        if (this.mediaIndex !== index) {
          media.codeType = 2
          shareTrackCode(media, this.shareTrackModel)
        }
      })
    },
    handleUseMobileTrackChange(val) {
      if (val === 0) {
        this.mediaModel.mobileTrackList = [{ trackTypeModel: 1, serviceProvider: '', code: '' }]
      }
    },
    handleMobileTrackDel(index) {
      if (this.mediaModel.mobileTrackList.length > 1) {
        this.mediaModel.mobileTrackList.splice(index, 1)
      } else {
        this.mediaModel.mobileTrackList = [{ trackTypeModel: 1, serviceProvider: '', code: '' }]
      }
    },
    handleMobileTrackAdd() {
      this.mediaModel.mobileTrackList.push({
        trackTypeModel: 1,
        serviceProvider: '',
        code: ''
      })
    },
    handleCodeTypeLandingChange(val) {
      if (val === 0) {
        this.mediaModel.trackListLanding = []
        this.mediaModel.clickTrackListLanding = []
        this.mediaModel.startTrackListLanding = []
        this.mediaModel.middleTrackListLanding = []
        this.mediaModel.endTrackListLanding = []
      }
    },
    setLandingPageTips(data) {
      this.mediaModel.landingTipsDetail[0] = data
    }
  }
}
</script>

<style lang="stylus" src="./materialOwnSource.styl" scoped></style>
